import { FC, useEffect } from "react";
import { usePlanLink, useSinglePole } from "../../../../hooks";
import { LinkPlan } from "../../../../types/link.types";
import LinkListView from "./LinkListView/LinkListView";
import LinkItem, {
  LinkItemContent,
} from "../../../../../../common/components/atom/LinkItem/LinkItem";
import { useMicroNavigator } from "../../../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import { useCapability } from "../../../../../rbac";


export const LinkListItemPresenter = ({ link }: { link: LinkPlan }) => {
  let contentRender: [FC, FC] = [() => <>o</>, () => <>o</>];
  const { navigate} = useMicroNavigator();
  const {deleteLink} = usePlanLink()
  const canEdit = useCapability('planbt.edit')
  const handleDelete = () => {
    deleteLink.mutate({linkId : link.pl_link_id})
  }

  const handleEdit = () => {
    navigate('edit', {linkId: link.pl_link_id})
  }

  const onClick = undefined

  if (link.pl_link_content_node_1.node_type === "POLE") {
    const poleItemRender = () => (
      <ItemContentPolePresenter
        poleId={link.pl_link_content_node_1.node_hosted_id}
      />
    );

    contentRender[0] = poleItemRender;
  }

  if (link.pl_link_content_node_2.node_type === "POLE") {
    const poleItemRender = () => (
      <ItemContentPolePresenter
        poleId={link.pl_link_content_node_2.node_hosted_id}
      />
    );

    contentRender[1] = poleItemRender;
  }

  return (
    <LinkItem handleDelete={canEdit ? handleDelete : undefined} handleEdit={canEdit ? handleEdit : undefined} contentRender={contentRender} variant="dark" onClick={onClick} />
  );
};

export const ItemContentPolePresenter = ({ poleId }: { poleId: string }) => {
  const { singlePoleQuery } = useSinglePole({ poleId });

  

  if (!singlePoleQuery.data) {
    return (
      <LinkItemContent
        titleHeader="Poteau"
        title="no data"
        iconName="electricPole"
        variant="dark"
      />
    );
  }

  if (singlePoleQuery.isLoading) {
    return (
      <LinkItemContent
        titleHeader="Poteau"
        title="..."
        iconName="electricPole"
        variant="dark"
      />
    );
  }

  return (
    <LinkItemContent
      titleHeader="Poteau"
      title={singlePoleQuery.data?.pole_name}
      iconName="electricPole"
      variant="dark"
    />
  );
};

export default function LinkListPresenter() {
  const { allLinkQuery: listLink } = usePlanLink();

  useEffect(() => {
    listLink.refetch()

  },[])// eslint-disable-line

  if (listLink.error) {
    return <p>{listLink.error.message|| 'erreur'}</p>
  }

  const listItemRender: FC[] =
    listLink?.data?.data?.map((link) =>{



      const render = () => <LinkListItemPresenter link={link}  />;
      return render;
    }) || [];
  return <LinkListView listItemView={listItemRender} isLoading={listLink.isLoading} />;
}
